import { createSelector } from '@reduxjs/toolkit';

const selectProjectBankArchiveJobsState = (state) =>
  state.projectBankArchiveJobs;

export const selectProjectBankArchiveJobs = createSelector(
  [selectProjectBankArchiveJobsState],
  (state) => state.jobs
);

export const selectProjectBankArchiveJobById = (state, archiveJobId) =>
  state.projectBankArchiveJobs.jobs[archiveJobId] || null;

export const selectRunningProjectBankArchiveJobs = createSelector(
  [selectProjectBankArchiveJobs],
  (jobs) => Object.values(jobs).filter((job) => job.status === 'RUNNING')
);
